import styled, { useTheme } from 'styled-components'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo, TypoVariant } from '@/components/common/typography'
import { IconNameEnum } from '@/constants/icon-name.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { useCustomRouter } from '@/containers/hooks'

interface ProductDetailInquiryProps {
  count: number
  id: number
}

export const ProductDetailInquiry = ({ count, id }: ProductDetailInquiryProps) => {
  const { color } = useTheme()
  const { push } = useCustomRouter()

  const handleClickInquiry = () => {
    push({
      pathname: ROUTES.PRODUCTS.INQUIRY,
      query: {
        productId: id,
      },
    })
  }

  return (
    <ProductDetailInquiryWrapper className="product-detail-inquiry" onClick={handleClickInquiry}>
      <div className="product-detail-inquiry__title">
        <Typo as="h2" variant={TypoVariant.Heading6Bold} color={color.gray900}>
          문의
        </Typo>
        <Typo variant={TypoVariant.Heading6Bold} color={color.blue500}>
          {count.toLocaleString('ko-KR') || 0}
        </Typo>
      </div>
      <FlatIcon type={IconNameEnum.IcChevronRight} size="2rem" color={color.gray900} />
    </ProductDetailInquiryWrapper>
  )
}

const ProductDetailInquiryWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .product-detail-inquiry {
    &__title {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.4rem;
    }
  }
`
